import React from 'react'

const supplierData = {
  id: 1,
  name: "John Supplier",
  image: "/assets/images/testimonial4.png",
  num_reviews: 1230,
  ratings: 4.5,
  ratings_count: 245,
  email: "john@supplier.com",
  phone: "(123) 456-7890",
  location: "Plano, TX, United States",
  feedback: [
    {
      buyer_id: 1,
      buyer_name: "John Doe",
      buyer_avatar: "/assets/images/testimonial3.png",
      buyer_ratings: "3.5",
      buyer_feedback: "Body text for your whole article or post. We’ll put in some lorem ipsum to show how a filled-out page might look."
    },

    {
      buyer_id: 2,
      buyer_name: "John Doe",
      buyer_avatar: "/assets/images/testimonial3.png",
      buyer_ratings: "3.5",
      buyer_feedback: "Body text for your whole article or post. We’ll put in some lorem ipsum to show how a filled-out page might look."
    },

    {
      buyer_id: 3,
      buyer_name: "John Doe",
      buyer_avatar: "/assets/images/testimonial3.png",
      buyer_ratings: "3.5",
      buyer_feedback: "Body text for your whole article or post. We’ll put in some lorem ipsum to show how a filled-out page might look."
    },

    {
      buyer_id: 4,
      buyer_name: "John Doe",
      buyer_avatar: "/assets/images/testimonial3.png",
      buyer_ratings: "3.5",
      buyer_feedback: "Body text for your whole article or post. We’ll put in some lorem ipsum to show how a filled-out page might look."
    },

    {
      buyer_id: 5,
      buyer_name: "John Doe",
      buyer_avatar: "/assets/images/testimonial3.png",
      buyer_ratings: "3.5",
      buyer_feedback: "Body text for your whole article or post. We’ll put in some lorem ipsum to show how a filled-out page might look."
    },

    {
      buyer_id: 6,
      buyer_name: "John Doe",
      buyer_avatar: "/assets/images/testimonial3.png",
      buyer_ratings: "3.5",
      buyer_feedback: "Body text for your whole article or post. We’ll put in some lorem ipsum to show how a filled-out page might look."
    },

  ],
  location: "United States"
}

const SupplierFeedback = () => {
  return (
    <div>
      <div className='text-2xl font-semibold'>
        Supplier Feedback
      </div>

      <div className='grid grid-cols-4 gap-3'>


        <div className='col-span-1 my-3 '>
          
          <div className='flex flex-col justify-center border-2'>
            <img className='w-[100px] rounded-full' src={supplierData.image} alt="" />
            <p className='font-semibold'>{supplierData.name}</p>
            <p>Ratings: {supplierData.ratings} ({supplierData.ratings_count})</p>
          </div>

          <div className='flex flex-col border-2'>
            <p>{supplierData.email}</p>
            <p>{supplierData.phone}</p>
            <p>{supplierData.location}</p>
          </div>
          
        </div>

        <div className='col-span-3 my-3 border-2'>
          <div>Supplier Feedback</div>
          
          {supplierData.feedback.map((review) => (
            <div>
              <div className='grid grid-cols-8'>

                <div className='w-[50px] col-span-1'>
                  <img className='rounded-full' src={review.buyer_avatar} alt="" />
                </div>

                <div className='col-span-1'>
                  <p>{review.buyer_name}</p>
                  <p>{review.buyer_ratings}</p>
                </div>

                <div className='col-span-6'>
                  <p>{review.buyer_feedback}</p>
                </div>

              </div>
            </div>
          ))}


        </div>
      </div>
    </div>
  )
}

const TestSupplier = () => {

  return (
    <div>
      <div className='grid grid-cols-5 items-center'>
        <div className='flex col-span-1 justify-center'>
          <img className='w-[100px] rounded-full' src={supplierData.image} alt="" />
        </div>

        <div className='col-span-4'>
          <div>
            <p className='text-lg font-semibold'>{supplierData.name} ({supplierData.ratings})</p>
          </div>

          <div className='flex gap-2 text-sm'>
            <button
              className="items-center rounded-xl bg-white px-6 py-1 text-red-800 shadow hover:bg-rose-500 hover:text-white transition duration-200"
            >
                {supplierData.num_reviews} reviews
            </button>

            <button
              className="items-center rounded-xl bg-white px-6 py-1 text-red-800 shadow hover:bg-rose-500 hover:text-white transition duration-200"
            >
                View other listings
            </button>

            <button
              className="items-center rounded-xl bg-white px-6 py-1 text-red-800 shadow hover:bg-rose-500 hover:text-white transition duration-200"
            >
                Contact
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}


const ProductDetails = () => {

  // Test Data

  const product = {

    id: 1,
    images: [
      "/assets/images/skincare-cream-jar.png",
      "/assets/images/serum-bottle.jpg",
      "/assets/images/pink-skincare-product.jpg",
      "/assets/images/face-cream-container.jpg",
      "/assets/images/skincare-jar-with-rings.jpg",
      "/assets/images/natural-skincare-products.png",
      "/assets/images/amber-skincare-bottles.jpg",
    ],
    name: "Sample Product Name",
    supplier: <TestSupplier/>,
    price: "324.99",
    shipping: "5.99",
    quantity: "12",
    delivery: "Within 3 to 5 days",
    return_policy: "No returns",
    payments: [
      "klarna",
      "paypal",
      "venmo",
    ],

    protection: "Guaranteed",

    category: "Automotive",
    materials: "Iron, Silicate",
    
    product_length: "23",
    product_width: "16",
    product_height: "5",

    weight: "20g",
    
    description:
    "Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. <br /> Ad litora torquent per conubia nostra inceptos himenaeos. Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos. Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos."

  }

  // const images = [
  //   { 
  //     id: 1,
  //     image: "/assets/images/skincare-cream-jar.png",
  //   },

  //   { 
  //     id: 2,
  //     image: "/assets/images/serum-bottle.jpg",
  //   },

  //   { 
  //     id: 3,
  //     image: "/assets/images/pink-skincare-product.jpg",
  //   },

  //   { 
  //     id: 4,
  //     image: "/assets/images/face-cream-container.jpg",
  //   },

  //   { 
  //     id: 5,
  //     image: "/assets/images/skincare-jar-with-rings.jpg",
  //   },

  //   { 
  //     id: 6,
  //     image: "/assets/images/natural-skincare-products.png",
  //   },

  //   { 
  //     id: 7,
  //     image: "/assets/images/amber-skincare-bottles.jpg",
  //   },

  // ]

  const similarProducts = [
    { 
      id: 1,
      image: "/assets/images/skincare-cream-jar.png",
      
      name: "Product 1",
      price: "$120.25",
      shipping: "Free Shipping",
      uptime: "15"
    },

    { 
      id: 2,
      image: "/assets/images/serum-bottle.jpg",
      
      name: "Product 2",
      price: "$126.25",
      shipping: "$4.25 Shipping",
      uptime: "15"
    },

    { 
      id: 3,
      image: "/assets/images/pink-skincare-product.jpg",
      
      name: "Product 3",
      price: "$1,220.25",
      shipping: "Free",
      uptime: "15"
    },

    { 
      id: 4,
      image: "/assets/images/face-cream-container.jpg",
      
      name: "Product 4",
      price: "$1,270.25",
      shipping: "Free",
      uptime: "15"
    },

    { 
      id: 5,
      image: "/assets/images/skincare-jar-with-rings.jpg",
      
      name: "Product 5",
      price: "$420.25",
      shipping: "Free",
      uptime: "15"
    },

    { 
      id: 6,
      image: "/assets/images/natural-skincare-products.png",
      
      name: "Product 6",
      price: "$350.25",
      shipping: "Free",
      uptime: "15"
    },

    { 
      id: 7,
      image: "/assets/images/amber-skincare-bottles.jpg",
      
      name: "Product 7",
      price: "$120.25",
      shipping: "Free",
      uptime: "15"
    },

  ]

  return (
    <div className='max-w-[1400px] mx-auto mt-3'>

        {/* Search Bar */}
        <div className="flex gap-3 mb-6 py-6 px-10">
          <input
            type="text"
            placeholder="Search for anything"
            value={""}
            className="flex-1 border border-gray-300 rounded-full px-5 py-2 text-sm outline-none"
          />
          <button className="bg-blue-600 text-white px-6 rounded-full text-sm">
            Search
          </button>
        </div>

        <div>
          <div className='grid grid-cols-2'>

            <div className='col-span-1'>
              
              <div className=''>
                <img src={product.images[0]} alt="" />
              </div>

              <div className='grid grid-cols-5'>

                {product.images.map((product_img) => (
                  <div className='flex flex-col items-center'>
                    <img className='w-100' src={product_img} alt="" />
                  </div>
                ))}

              </div>

            </div>

            <div className='col-span-1'>

              <div className='text-2xl font-semibold'>
                {product.name}
              </div>

              <div className=''>
                {product.supplier}
              </div>

              <div className='text-3xl font-semibold'>
                US ${product.price}
              </div>

              <div className=''>
                <button
                  className="w-full bg-red-800 items-center rounded-xl px-6 py-1 text-white shadow hover:bg-rose-400 hover:text-white transition duration-200"
                >
                  Request a Quote
                </button>
              </div>

              <div className='grid grid-cols-5'>
                <div className='col-span-1'><span className='font-semibold'>Shipping: </span></div>
                <div className='col-span-4'>{product.shipping}</div>
                
              </div>

              <div className='grid grid-cols-5'>
                <div className='col-span-1'><span className='font-semibold'>Delivery: </span></div>
                <div className='col-span-4'>{product.delivery}</div>
                
              </div>

              <div className='grid grid-cols-5'>
                <div className='col-span-1'><span className='font-semibold'>Return Policy: </span></div>
                <div className='col-span-4'>{product.return_policy}</div>
                
              </div>

              <div className='grid grid-cols-5'>
                <div className='col-span-1'><span className='font-semibold'>Payments: </span></div>

                {product.payments.map((payment) => (
                    <p>{payment}</p>
                ))}
                
              </div>

              <div className='grid grid-cols-5'>
                <div className='col-span-1'><span className='font-semibold'>Buyer Protection: </span></div>
                <div className='col-span-4'>{product.protection}</div>
                
              </div>

            </div>


          </div>

          <div>
            <div className='text-2xl font-semibold'>
              Similar Products
            </div>
              
            <div className='grid grid-cols-5'>
              
              {similarProducts.map((product) => (
                <div className='flex flex-col m-2 border rounded-lg'>
                  <div className='h-[150px] mb-2'>
                    <img className='max-w-[150px] max-h-[150px] object-cover rounded-lg' src={product.image} alt="" />
                  </div>

                  <div className=''>
                    
                    <p className='text-lg'>{product.name}</p>
                    <p className='text-lg font-semibold'>{product.price}</p>
                    <p className='text-sm text-gray-700'>{product.shipping}</p>
                    
                  </div>
                </div>
              ))}

            </div>
          </div>

          <div>
            <div className='text-2xl font-semibold'>
              Deals
            </div>
              
            <div className='grid grid-cols-5'>
              
              {similarProducts.map((product) => (
                <div className='flex flex-col m-2 border rounded-lg'>
                  <div className='h-[150px] mb-2'>
                    <img className='max-w-[150px] max-h-[150px] object-cover rounded-lg' src={product.image} alt="" />
                  </div>

                  <div className=''>
                    
                    <p className='text-lg'>{product.name}</p>
                    <p className='text-lg font-semibold'>{product.price}</p>
                    <p className='text-sm text-gray-700'>{product.shipping}</p>
                    
                  </div>
                </div>
              ))}

            </div>
          </div>

          <div>
            <div className='text-2xl font-semibold'>
              Product Specs
            </div>

            <div className='grid grid-cols-2'>


              <div className='grid grid-cols-2'>

                <div className='font-semibold'>
                  <p>Materials</p>
                  <p>Category</p>
                  <p>Dimensions</p>
                </div>

                <div className=''>
                  <p>{product.materials}</p>
                  <p>{product.category}</p>
                  <p>{product.product_length} x {product.product_width} x {product.product_height}</p>
                </div>

                
                
              </div>
              
            </div>
          </div>

          <div>
            
            <div className='text-2xl font-semibold'>
              Product Description
            </div>

            <div>
              <p>
                {product.description}
              </p>
            </div>
            
          </div>

          <SupplierFeedback/>

        </div>

        
        

    </div>
  )
}

export default ProductDetails